import clsx from 'clsx';
import React, { useState } from 'react';

import { useFollows } from '../../../hooks';
import { FOLLOWER, FOLLOWING } from '../../../utils/backend-api/subscriber_directory';
import { Divider } from '../../BaseUI';
import FollowModal from './FollowModal';
import FollowShortHand from './FollowShortHand';
import styles from './styles.module.scss';

const MIN_SHORT_HAND_COUNT = 3;

const FollowStatusBanner = ({
  followers,
  following,
  totalFollowers,
  totalFollowing,
  username,
  queryClient,
}) => {
  const [currentActiveTab, setCurrentActiveTab] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const shortHandAvatar = followers
    .slice(0, 3)
    .reverse()
    .map((follower) => follower.pictureUrl);

  const {
    data: followersData,
    fetchNextPage: fetchFollowers,
    hasNextPage: followersHasNextPage,
    isLoading: isFollowersLoading,
  } = useFollows({ followType: FOLLOWER, username });

  const {
    data: followingsData,
    fetchNextPage: fetchFollowings,
    hasNextPage: followingsHasNextPage,
    isLoading: isFollowingsLoading,
  } = useFollows({ followType: FOLLOWING, username });

  const clickHandler = (tabName, updateModalStatus) => {
    setCurrentActiveTab(tabName);
    if (updateModalStatus) {
      setIsModalOpen(!isModalOpen);
    }
  };

  const handlePageChange = () => {
    currentActiveTab === FOLLOWER ? fetchFollowers() : fetchFollowings();
  };

  const isLoading = currentActiveTab === FOLLOWER ? isFollowersLoading : isFollowingsLoading;
  const hasNextPage = currentActiveTab === FOLLOWER ? followersHasNextPage : followingsHasNextPage;
  const currentActiveList = currentActiveTab === FOLLOWER ? followersData : followingsData;

  return (
    <>
      <FollowModal
        currentActiveTab={currentActiveTab}
        currentActiveList={currentActiveList}
        clickHandler={clickHandler}
        handlePageChange={handlePageChange}
        hasNextPage={hasNextPage}
        isLoading={isLoading}
        isModalOpen={isModalOpen}
        queryClient={queryClient}
        setIsModalOpen={setIsModalOpen}
        totalFollowers={totalFollowers}
        totalFollowing={totalFollowing}
        username={username}
      />
      <div className={styles.followBannerContainer}>
        <div className={styles.followStatus}>
          {totalFollowers > 0 && (
            <div
              className={clsx(styles.followContainer, followers.length <= 0 ? styles.disabled : '')}
              onClick={() => clickHandler(FOLLOWER, true)}
              data-test-id="follow-container"
            >
              <span className={styles.number}>{totalFollowers}</span>{' '}
              <span className={styles.headerFollow}>Follower{totalFollowers > 1 ? 's' : ''}</span>
            </div>
          )}
          {totalFollowing > 0 && (
            <div
              className={clsx(styles.followContainer, following.length <= 0 ? styles.disabled : '')}
              onClick={() => clickHandler(FOLLOWING, true)}
              data-test-id="follow-container"
            >
              <span className={styles.number}>{totalFollowing}</span>{' '}
              <span className={styles.headerFollow}>Following</span>
            </div>
          )}
        </div>
        <Divider />
        {totalFollowers >= MIN_SHORT_HAND_COUNT && (
          <FollowShortHand
            styles={styles}
            shortHandAvatar={shortHandAvatar}
            followers={followers}
            totalFollowers={totalFollowers}
          />
        )}
      </div>
    </>
  );
};

export default FollowStatusBanner;
